import React, { useState, useEffect } from 'react';
import { useDrop } from 'react-dnd';
import Element from './Element';
import { v4 as uuidv4 } from 'uuid';
import { RxCross1 } from 'react-icons/rx';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CREATION_ERROR, getAllFields, getAllForms, getAllPanels, getAllTemplates } from '../../Redux/Actions/Actions';
import AlertPopUp from '../Reusable_Components/Alert';
import { IoInformationCircleSharp } from 'react-icons/io5';
import { TiTick } from "react-icons/ti";
import { MdCropPortrait, MdCropLandscape } from 'react-icons/md';

const FormCanvas = (props) => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const modal = useSelector((state) => state.showModal)
  const creationError = useSelector((state) => state.creationError)
  const panelsList = useSelector((state) => state.panelsList)
  const templatesList = useSelector((state) => state.templatesList)
  const fieldsList = useSelector((state) => state.fieldsList)
  const formsList = useSelector((state) => state.formsList)

  const [droppedItems, setDroppedItems] = useState([])
  const [currentElement, setCurrentElement] = useState({})
  const [containers, setContainers] = useState([])
  const [position, setPosition] = useState()
  const [containerId, setContainerId] = useState()
  const [description, setDescription] = useState("")
  const [panelName, setPanelName] = useState("")
  const [templateName, setTemplateName] = useState("")
  const [formName, setFormName] = useState("")
  const [formType, setFormType] = useState("")
  const [formData, setFormData] = useState({})
  const [templateId, setTemplateId] = useState("")
  const [nameError, setNameError] = useState(null)
  const [showFieldInfo, setShowFieldInfo] = useState(false)

  const [autoPopulatedFields, setAutoPopulatedFields] = useState([
    "Asset",
    "Work Group",
    "Location",
    "Frequency",
    "Rating/Make",
    "Date",
  ])
  const [autoPopulatedFieldsSuccess, setAutoPopulatedFieldsSuccess] = useState(false)
  const [outlineVisible, setOutlineVisible] = useState(false);
  const [tableHistory, setTableHistory] = useState({});
  const [formOrientation, setFormOrientation] = useState("portrait");

  const canvasMaxWidth = formOrientation === "landscape" ? "297mm" : "210mm";

  const pushTableHistory = (id, snapshot) => {
    setTableHistory(prev => {
      const stack = prev[id] || []
      const next = [...stack, snapshot]
      if (next.length > 50) next.shift()
      return { ...prev, [id]: next }
    })
  }

  useEffect(() => {
    !fieldsList && dispatch(getAllFields())
    !panelsList && dispatch(getAllPanels())
    !templatesList && dispatch(getAllTemplates())
    !formsList && dispatch(getAllForms())

    setShowFieldInfo(true)
  }, [])

  useEffect(() => {
    if (outlineVisible) {
      const timer = setTimeout(() => {
        setOutlineVisible(false);
      }, 1000); // 1 second

      return () => clearTimeout(timer);
    }
  }, [outlineVisible]);

  useEffect(() => {
    modal === false && setContainers([])
    modal === false && setCurrentElement({})
  }, [modal])

  useEffect(() => {
    if (props?.name === "templateClone" && props?.data) {
      const sourceItems = Array.isArray(props.data) ? props.data : props.data.items
      const sourceOrientation = Array.isArray(props.data) ? "portrait" : (props.data.orientation || "portrait")
      const clonedData = JSON.parse(JSON.stringify(sourceItems)).map(container => ({
        ...container,
        id: uuidv4(),
        items: container.items.map(item => ({ ...item, id: uuidv4() }))
      }))
      setContainers(clonedData)
      setFormOrientation(sourceOrientation)
    }
  }, [])

  const determineDropPosition = (clientOffset, containerId) => {
    const containerRect = document.getElementById(containerId)?.getBoundingClientRect();
    const offsetX = clientOffset?.x - containerRect?.left;
    const offsetY = clientOffset?.y - containerRect?.top;

    if (offsetY < containerRect?.height / 4) {
      return "above";
    } else if (offsetY > (containerRect?.height / 4) * 3) {
      return "below";
    } else if (offsetX < containerRect?.width / 2) {
      return "left";
    } else {
      return "right";
    }
  };

  const handleDrop = (item, monitor) => {
    setAutoPopulatedFieldsSuccess(false)
    //  console.log(document.elementFromPoint(monitor.getClientOffset().x,monitor.getClientOffset().y)?.closest('.container')?.id)
    const containerId = document.elementFromPoint(monitor.getClientOffset().x, monitor.getClientOffset().y)?.closest('.container')?.id
    //  console.log(determineDropPosition(monitor.getClientOffset(),containerId)) 
    const droppedPosition = determineDropPosition(monitor.getClientOffset(), containerId)
    const indexPosition = (containerId?.split(" ")[1])
    const id = uuidv4()
    let newItem
    switch (item.type) {
      case "input":
        newItem = { ...item, id, content: "Input" }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        setCurrentElement({ ...item, id, content: "Input" })
        break;
      case "inputWithLabel":
        newItem = { ...item, id, content: "Input", width: 20 }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        setCurrentElement({ ...item, id, content: "Input" })
        break;
      case "paragraph":
        newItem = { ...item, id, content: "Paragraph", width: 100, textAlignment: "start" }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        setCurrentElement(newItem)
        break;
      case "checkbox":
        newItem = { ...item, id, content: "Checkbox" }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        // setDroppedItems((droppedItems) => [...droppedItems, { ...item, id, content: "Checkbox" }])
        setCurrentElement({ ...item, id, content: "Checkbox" })
        break;
      case "textarea":
        newItem = { ...item, id, content: "Textarea" }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        // setDroppedItems((droppedItems) => [...droppedItems, { ...item, id, content: "Textarea" }])
        setCurrentElement({ ...item, id, content: "Textarea" })
        break;
      case "text":
        newItem = { ...item, id, content: "Text", size: "h1", textAlignment: "start" }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        setCurrentElement({ ...item, id, content: "Text", size: "h1", textAlignment: "start" })
        break;
      case "table":
        newItem = { ...item, id, content: "Table", rows: 3, columns: 3, columnNames: ["column1", "column2", "column3"], columnsType: ["text", "text", "text"], columnsOptions: ["", "", ""], headerAlign: "start", tableData: [[{ type: "text", content: "text" }, { type: "text", content: "text" }, { type: "text", content: "text" }], [{ type: "text", content: "text" }, { type: "text", content: "text" }, { type: "text", content: "text" }], [{ type: "text", content: "text" }, { type: "text", content: "text" }, { type: "text", content: "text" }]] }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        setCurrentElement({ ...newItem })
        break;
      case "radio":
        newItem = { ...item, id, content: "Radio", noOfOptions: 2, options: [{ label: "A" }, { label: "B" }] }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        setCurrentElement({ ...newItem })
        break;
      case "upload":
        newItem = { ...item, id, content: "Text", size: "h1" }
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        setCurrentElement({ ...item, id, content: "Text", size: "h1" })
        break;
      case "toggle":
        newItem = { ...item, id, content: "Toggle" }
        setCurrentElement(newItem)
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        break;
      case "dropdown":
        newItem = { ...item, id, content: "Dropdown", options: ["A", "B", "C"] }
        setCurrentElement(newItem)
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        break;
      case "date":
        newItem = { ...item, id, content: "Date" }
        setCurrentElement(newItem)
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        break;
      case "toggleInput":
        newItem = { ...item, id, content: "Toggle with input" }
        setCurrentElement(newItem)
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        break;
      case "image":
        newItem = { ...item, id, content: "Image", width: 500, height: 200 }
        setCurrentElement(newItem)
        setContainers((containers) => [{ id: uuidv4(), items: [newItem] }])
        break;
      case "field":
        if (containerId) {
          let json_data_parsed = JSON.parse(item.json_data)
          json_data_parsed = { ...json_data_parsed, id: uuidv4(), auto_populate: item?.auto_populate ? item.auto_populate : false }
          if (json_data_parsed.tableData) {
            json_data_parsed.tableData = JSON.parse(JSON.stringify(json_data_parsed.tableData))
          }
          switch (droppedPosition) {
            case "above":
              json_data_parsed?.type === 'table' && setCurrentElement(json_data_parsed)
              setContainers((containers) => {
                const newContainer = { id: uuidv4(), items: [json_data_parsed] };
                return [...containers.slice(0, indexPosition), newContainer, ...containers.slice(indexPosition)];
              });
              break;
            case "below":
              json_data_parsed?.type === 'table' && setCurrentElement(json_data_parsed)
              setContainers((containers) => {
                const newContainer = { id: uuidv4(), items: [json_data_parsed] };
                return [...containers.slice(0, indexPosition + 1), newContainer, ...containers.slice(indexPosition + 1)];
              });
              break;
            case "left": {
              const targetIdx = Number(indexPosition)
              json_data_parsed?.type === 'table' && setCurrentElement(json_data_parsed)
              setContainers((prev) =>
                prev.map((container, idx) =>
                  idx === targetIdx
                    ? { ...container, items: [json_data_parsed, ...container.items] }
                    : container
                )
              );
              break;
            }
            case "right": {
              const targetIdx = Number(indexPosition)
              json_data_parsed?.type === 'table' && setCurrentElement(json_data_parsed)
              setContainers((prev) =>
                prev.map((container, idx) =>
                  idx === targetIdx
                    ? { ...container, items: [...container.items, json_data_parsed] }
                    : container
                )
              );
              break;
            }
            default:
              break;
          }
        } else {
          let json_data_parsed = JSON.parse(item?.json_data)
          json_data_parsed = { ...json_data_parsed, id: uuidv4(), auto_populate: item?.auto_populate ? item.auto_populate : false }
          if (json_data_parsed.tableData) {
            json_data_parsed.tableData = JSON.parse(JSON.stringify(json_data_parsed.tableData))
          }
          json_data_parsed?.type === 'table' && setCurrentElement(json_data_parsed)
          setContainers((containers) => [...containers, { id: uuidv4(), items: [json_data_parsed] }])
        }
        break;
      case "panel":
        let { json_data } = item
        const parsedPanel = JSON.parse(json_data)
        const panelItems = Array.isArray(parsedPanel) ? parsedPanel : (parsedPanel?.items || [])
        json_data = panelItems.map(container => ({
          ...container,
          id: uuidv4(),
          items: container.items.map(ci => ({ ...ci, id: uuidv4(), tableData: ci.tableData ? JSON.parse(JSON.stringify(ci.tableData)) : ci.tableData }))
        }))
        if (containerId) {
          switch (droppedPosition) {
            case "above":
              // item.items.type === 'table' && setCurrentElement(item.items)
              setContainers((containers) => {
                // const newContainer = { id: uuidv4(), items: [item.items] };
                return [...containers.slice(0, indexPosition), ...json_data, ...containers.slice(indexPosition)];
              });
              break;
            case "below":
              // item.items.type === 'table' && setCurrentElement(item.items)
              setContainers((containers) => {
                // const newContainer = { id: uuidv4(), items: [item.items] };
                return [...containers.slice(0, indexPosition + 1), ...json_data, ...containers.slice(indexPosition + 1)];
              });
              break;
            // case "left":
            //   // item.items.type === 'table' && setCurrentElement(item.items)
            //   setContainers((containers) => {
            //     const updatedContainers = [...containers]
            //     const currentContainer = updatedContainers[indexPosition];
            //     currentContainer.items.unshift(item.items); // Add item/items at the start of the items array
            //     return updatedContainers;
            //   });
            //   break;
            // case "right":
            // item.items.type === 'table' && setCurrentElement(item.items)
            // setContainers((containers) => {
            //   const updatedContainers = [...containers]
            //   const currentContainer = updatedContainers[indexPosition];
            //   currentContainer.items.push(item.items); // Add item/items at the start of the items array
            //   return updatedContainers;
            // });
            // break;
            default:
              setContainers((containers) => [...containers, ...json_data])
              break;
          }
        } else {
          setContainers((containers) => [...containers, ...json_data])
        }
        break;
      case "template": {
        setTemplateId((templateId) => item.template_id)
        const parsedTemplate = JSON.parse(item.json_data)
        const templateItems = Array.isArray(parsedTemplate) ? parsedTemplate : (parsedTemplate?.items || [])
        const templateOrientation = Array.isArray(parsedTemplate) ? null : parsedTemplate?.orientation
        setContainers((containers) => templateItems.map(container => ({
          ...container,
          id: uuidv4(),
          items: container.items.map(ci => ({ ...ci, id: uuidv4(), tableData: ci.tableData ? JSON.parse(JSON.stringify(ci.tableData)) : ci.tableData }))
        })))
        if (templateOrientation === "landscape" || templateOrientation === "portrait") {
          setFormOrientation(templateOrientation)
        }
        break
      }
      default:
        break;
    }
    setPosition("")
    setFormData({})
  }

  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: 'FORM_ELEMENT',
    drop: (item, monitor) => {
      // Handle dropped item
      handleDrop(item, monitor)
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));


  const handleDeleteElement = (id) => {
    setDroppedItems(droppedItems.filter(item => item.id !== id))
  }

  const handleColumnNameChange = (i, id) => {
    setDroppedItems(droppedItems.map((item) => {
      if (item.id === id) {
        item.columnNames[i].editOption ? item.columnNames[i].editOption = false : item.columnNames[i].editOption = true
        return item
      } else {
        return item
      }
    }))
  }

  const handleChangeCurrentElement = (id) => {
    let filteredContainers = containers.filter(container =>
      container.items.some(item => item.id === id)
    );
    const currentObject = filteredContainers[0].items.filter((item) => item.id === id)[0]
    setCurrentElement(currentObject)
  }

  const changeInputContent = (e, id) => {
    setCurrentElement({ ...currentElement, content: e.target.value, label: e.target.value })
    containers.forEach(container => {
      container.items.forEach(item => {
        if (item.id === id) {
          item.content = e.target.value;
          item.label = e.target.value;
        }
      });
    });
    setContainers(containers);
  }

  const changeCheckboxContent = (e, id) => {
    setCurrentElement({ ...currentElement, content: e.target.value })
    containers.forEach(container => {
      container.items.forEach(item => {
        if (item.id === id) {
          item.content = e.target.value;
          item.label = e.target.value;
        }
      });
    });
    setContainers(containers);
  }
  const changeTextareaLabel = (e, id) => {
    setCurrentElement({ ...currentElement, content: e.target.value, label: e.target.value })
    containers.forEach(container => {
      container.items.forEach(item => {
        if (item.id === id) {
          item.content = e.target.value;
          item.label = e.target.value;
        }
      });
    });
    setContainers(containers);
  }

  const changeTextSize = (e, id) => {
    setCurrentElement({ ...currentElement, size: e.target.value })
    containers.forEach(container => {
      container.items.forEach(item => {
        if (item.id === id) {
          item.size = e.target.value;
        }
      });
    });
    setContainers(containers);
  }

  const changeTextAlignment = (e, id) => {
    setCurrentElement({ ...currentElement, textAlignment: e.target.value })
    containers.forEach(container => {
      container.items.forEach(item => {
        if (item.id === id) {
          item.textAlignment = e.target.value;
        }
      });
    });
    setContainers(containers);
  }

  const changeTextContent = (e, id) => {
    setCurrentElement({ ...currentElement, content: e.target.value, label: e.target.value })
    containers.forEach(container => {
      container.items.forEach(item => {
        if (item.id === id) {
          item.content = e.target.value;
          item.label = e.target.value
        }
      });
    });
    setContainers(containers);
  }

  const handleSave = () => {
    if (props.name === "fields") {
      const item = {
        id: uuidv4(),
        type: "field",
        fieldType: containers[0]?.items[0]?.type,
        fieldName: containers[0]?.items[0]?.content,
        items: containers[0]?.items[0],
        description: description
      }
      const { handleSaveNewField } = props
      handleSaveNewField(item)
    } else if (props.name === "panels") {
      const item = {
        id: uuidv4(),
        type: "panel",
        description: description,
        panelName: panelName,
        items: containers,
        createdAt: new Date()
      }
      const { handleSaveNewPanel } = props
      handleSaveNewPanel(item)
      // setContainers([])
      // setCurrentElement({})
      // setDescription("")
      // setPanelName("")
    } else if (props.name === "templates") {
      const item = {
        id: uuidv4(),
        type: "template",
        description: description,
        templateName: templateName,
        items: containers,
        orientation: formOrientation,
        createdAt: new Date()
      }
      const { handleSaveNewTemplate } = props
      handleSaveNewTemplate(item)
      // setContainers([])
      // setCurrentElement({})
      // setDescription("")
      // setTemplateName("")
    } else if (props.name === "templateClone") {
      const item = {
        id: uuidv4(),
        type: "template",
        description: description,
        templateName: templateName,
        items: containers,
        orientation: formOrientation,
        createdAt: new Date()
      }
      const { handleSaveNewTemplate } = props
      handleSaveNewTemplate(item)
      // setContainers([])
      // setCurrentElement({})
      // setDescription("")
      // setTemplateName("")
    } else if (props.name === "forms") {
      const item = {
        id: uuidv4(),
        type: "form",
        description: description.trim(),
        formName: formName.trim(),
        formType: formType,
        items: containers,
        templateId: templateId,
        orientation: formOrientation,
        createdAt: new Date()
      }
      const { handleSaveNewForm } = props
      handleSaveNewForm(item)
      // setContainers([])
      // setCurrentElement({})
      // setDescription("")
      // setTemplateName("")
    }
  }

  const findItemById = (id) => {
    for (const c of containers) {
      for (const item of c.items) {
        if (item.id === id) return item
      }
    }
    return null
  }

  const writeItemUpdate = (id, updates) => {
    setContainers(prevContainers =>
      prevContainers.map(container => ({
        ...container,
        items: container.items.map(item =>
          item.id === id ? { ...item, ...updates } : item
        )
      }))
    )
    if (currentElement?.id === id) {
      setCurrentElement(prev => ({ ...prev, ...updates }))
    }
  }

  const handleDecreaseRows = (id) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.tableData) return
    const newTableData = target.tableData.slice(0, -1)
    const newRows = (target.rows || 0) <= 0 ? 0 : target.rows - 1
    writeItemUpdate(id, { rows: newRows, tableData: newTableData })
  }
  const handleIncreaseRows = (id) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.tableData || !target?.columnsType) return
    let newRow = [];
    target.columnsType.forEach(type => {
      if (type === "text") {
        newRow.push({ type: "text", content: "text", rowspan: 1, colspan: 1 });
      } else if (type === "toggle") {
        newRow.push({ type: "toggle", content: "", rowspan: 1, colspan: 1 });
      } else if (type === "input") {
        newRow.push({ type: "input", content: "", rowspan: 1, colspan: 1 });
      } else if (type === "image") {
        newRow.push({ type: "image", content: "", rowspan: 1, colspan: 1 });
      } else if (type === "dropdown") {
        newRow.push({ type: "dropdown", content: "", rowspan: 1, colspan: 1 });
      } else if (type === "date") {
        newRow.push({ type: "date", content: "", rowspan: 1, colspan: 1 });
      }
    });
    const newTableData = [...target.tableData, newRow]
    writeItemUpdate(id, { rows: (target.rows || 0) + 1, tableData: newTableData })
  }
  const handleDecreaseColumns = (id) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.columnNames || !target?.tableData) return
    const newColumnNames = target.columnNames.slice(0, -1)
    const newColumnsType = (target.columnsType || []).slice(0, -1)
    const newColumnsOptions = (target.columnsOptions || []).slice(0, -1)
    const newTableData = target.tableData.map(row => row.slice(0, -1))
    const newColumns = (target.columns || 0) <= 0 ? 0 : target.columns - 1
    writeItemUpdate(id, {
      columns: newColumns,
      columnNames: newColumnNames,
      tableData: newTableData,
      columnsType: newColumnsType,
      columnsOptions: newColumnsOptions,
    })
  }
  const handleIncreaseColumns = (id) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.columnNames || !target?.tableData) return
    const newTableData = target.tableData.map(row => [...row, { type: "text", content: "text", rowspan: 1, colspan: 1 }])
    const newColumnsType = [...(target.columnsType || []), "text"]
    const newColumnsOptions = [...(target.columnsOptions || []), ""]
    const newColumnNames = [...target.columnNames, `column${target.columnNames.length + 1}`]
    writeItemUpdate(id, {
      columns: (target.columns || 0) + 1,
      columnNames: newColumnNames,
      tableData: newTableData,
      columnsType: newColumnsType,
      columnsOptions: newColumnsOptions,
    })
  }

  const handleChangeColumnName = (e, index, id) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.columnNames) return
    const newColumnNames = target.columnNames.map((name, i) => i === index ? e.target.value : name)
    writeItemUpdate(id, { columnNames: newColumnNames })
  }

  const handleChangeColumnType = (e, id, index) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.columnsType || !target?.tableData) return
    const newType = e.target.value
    const newColumnsType = target.columnsType.map((type, i) => i === index ? newType : type)
    const existingOptions = target.columnsOptions || target.columnNames.map(() => "")
    const newColumnsOptions = existingOptions.length < target.columnNames.length
      ? [...existingOptions, ...target.columnNames.slice(existingOptions.length).map(() => "")]
      : existingOptions
    const newTableData = target.tableData.map(row =>
      row.map((cell, cIdx) =>
        cIdx === index
          ? { ...cell, type: newType, content: "", src: undefined, options: newType === "dropdown" ? "" : undefined }
          : cell
      )
    )
    writeItemUpdate(id, { columnsType: newColumnsType, columnsOptions: newColumnsOptions, tableData: newTableData })
  }

  const handleChangeColumnOptions = (e, id, index) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.columnNames) return
    const rawValue = e.target.value
    const existingOptions = target.columnsOptions || target.columnNames.map(() => "")
    const padded = existingOptions.length < target.columnNames.length
      ? [...existingOptions, ...target.columnNames.slice(existingOptions.length).map(() => "")]
      : existingOptions
    const newColumnsOptions = padded.map((opts, i) => i === index ? rawValue : opts)
    writeItemUpdate(id, { columnsOptions: newColumnsOptions })
  }

  const handleChangeCellType = (id, rowIndex, colIndex, newType) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.tableData) return
    const newTableData = target.tableData.map((row, rIdx) =>
      rIdx === rowIndex
        ? row.map((cell, cIdx) =>
            cIdx === colIndex
              ? { ...cell, type: newType, content: "", src: undefined, options: newType === "dropdown" ? "" : undefined }
              : cell
          )
        : row
    )
    writeItemUpdate(id, { tableData: newTableData })
  }

  const handleChangeCellOptions = (id, rowIndex, colIndex, optionsStr) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.tableData) return
    const newTableData = target.tableData.map((row, rIdx) =>
      rIdx === rowIndex
        ? row.map((cell, cIdx) =>
            cIdx === colIndex ? { ...cell, options: optionsStr } : cell
          )
        : row
    )
    writeItemUpdate(id, { tableData: newTableData })
  }

  const changeTableData = (e, id, index) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.tableData) return
    const align = e.target.value
    const newTableData = target.tableData.map(row =>
      row.map((cell, cellIndex) =>
        cellIndex === index ? { ...cell, textAlign: align } : cell
      )
    )
    writeItemUpdate(id, { tableData: newTableData })
  }

  const handleChangeColumnHeaderAlign = (e, id, index) => {
    const target = findItemById(id) || (currentElement?.id === id ? currentElement : null)
    if (!target?.columnNames) return
    const align = e.target.value
    const colCount = target.columnNames.length || 0
    const next = Array.isArray(target.columnsHeaderAlign)
      ? [...target.columnsHeaderAlign]
      : new Array(colCount).fill(target.headerAlign || "start")
    while (next.length < colCount) {
      next.push(target.headerAlign || "start")
    }
    next[index] = align
    writeItemUpdate(id, { columnsHeaderAlign: next })
  }

  const handleChangeHeaderAlign = (e, id) => {
    const newHeaderAlign = e.target.value
    writeItemUpdate(id, { headerAlign: newHeaderAlign })
  }

  const handleResetTableMerges = (id) => {
    const target = findItemById(id)
    if (!target?.tableData) return
    pushTableHistory(id, target.tableData)
    const newTableData = target.tableData.map(row =>
      row.map(cell => ({ ...cell, rowspan: 1, colspan: 1 }))
    )
    setContainers(prevContainers =>
      prevContainers.map(container => ({
        ...container,
        items: container.items.map(item =>
          item.id === id ? { ...item, tableData: newTableData } : item
        )
      }))
    )
    if (currentElement?.id === id) {
      setCurrentElement({ ...currentElement, tableData: newTableData })
    }
  }

  const handleUndoTable = (id) => {
    const stack = tableHistory[id] || []
    if (stack.length === 0) return
    const previous = stack[stack.length - 1]
    setTableHistory(prev => ({ ...prev, [id]: stack.slice(0, -1) }))
    setContainers(prevContainers =>
      prevContainers.map(container => ({
        ...container,
        items: container.items.map(item =>
          item.id === id ? { ...item, tableData: previous } : item
        )
      }))
    )
    if (currentElement?.id === id) {
      setCurrentElement({ ...currentElement, tableData: previous })
    }
  }

  const handleTabelData = (id, tableData) => {
    const cleanedTableData = tableData.map(row =>
      row.map(cell => {
        const { edit, ...rest } = cell
        return rest
      })
    )
    const target = findItemById(id)
    if (target?.tableData) {
      pushTableHistory(id, target.tableData)
    }
    setContainers(prevContainers =>
      prevContainers.map(container => ({
        ...container,
        items: container.items.map(item =>
          item.id === id ? { ...item, tableData: cleanedTableData } : item
        )
      }))
    )
    if (currentElement?.id === id) {
      setCurrentElement({ ...currentElement, tableData: cleanedTableData })
    }
  }

  const handleDeleteRadioOption = (id, index) => {
    setCurrentElement({ ...currentElement, options: currentElement.options.filter((option, i) => i != index) })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          item.options = item.options.filter((option, i) => i != index)
        }
      });
    });
    setContainers(containers);
  }

  const handleAddNewOption = (id) => {
    const { options } = currentElement
    setCurrentElement({ ...currentElement, options: [...options, { label: "" }] })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          const { options } = item
          item.options = [...options, { label: "" }]
        }
      });
    });
    setContainers(containers);
  }

  const handleRadioLabel = (e, id) => {
    setCurrentElement({ ...currentElement, content: e.target.value, label: e.target.value })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          item.content = e.target.value
          item.label = e.target.value
        }
      });
    });
    setContainers(containers);
  }

  const handleEditRadioOption = (e, id, index) => {
    let { options } = currentElement
    options[index].label = e.target.value
    setCurrentElement({ ...currentElement, options: options })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          const { options } = item
          options[index].label = e.target.value
        }
      });
    });
    setContainers(containers);
  }

  const handleEditdropdownOption = (e, id, index) => {
    let { options } = currentElement
    options[index] = e.target.value
    setCurrentElement({ ...currentElement, options: options })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          const { options } = item
          options[index] = e.target.value
        }
      });
    });
    setContainers(containers);
  }
  const handleDeleteDropdownOption = (id, index) => {
    setCurrentElement({ ...currentElement, options: currentElement.options.filter((option, i) => i != index) })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          item.options = item.options.filter((option, i) => i != index)
        }
      });
    });
    setContainers(containers);
  }
  const handleAddNewDropdownOption = (id) => {
    const { options } = currentElement
    setCurrentElement({ ...currentElement, options: [...options, ""] })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          const { options } = item
          item.options = [...options, ""]
        }
      });
    });
    setContainers(containers);
  }

  const changeToggleContent = (e, id) => {
    setCurrentElement({ ...currentElement, content: e.target.value, label: e.target.value })
    containers.forEach(container => {
      container.items.forEach(item => {
        if (item.id === id) {
          item.content = e.target.value;
          item.label = e.target.value;
        }
      });
    });
    setContainers(containers);
  }

  const changeParaWidth = (e, id) => {
    setCurrentElement({ ...currentElement, width: (e.target.value === "" || e.target.value === "Na") ? "" : parseInt(e.target.value) })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          item.width = (e.target.value === "" || e.target.value === "Na") ? "" : parseInt(e.target.value)
        }
      });
    });
    setContainers(containers);
  }

  const handleDeleteItem = (id) => {
    // let containerIndex = -1;
    // let itemIndex = -1;
    // containers.forEach((container, index) => {
    //   const foundItemIndex = container.items.findIndex(item => item.id === id);
    //   if (foundItemIndex !== -1) {
    //     containerIndex = index;
    //     itemIndex = foundItemIndex;
    //   }
    // });

    // If the item is found, remove it from the items array
    // if (containerIndex !== -1 && itemIndex !== -1) {
    //   const updatedItems = [...containers[containerIndex].items];
    //   updatedItems.splice(itemIndex, 1);
    //   const updatedContainerArray = [...containers];
    //   updatedContainerArray[containerIndex].items = updatedItems;

    //   // If the items array is empty, remove the container object
    //   if (updatedItems.length === 0) {
    //     updatedContainerArray.splice(containerIndex, 1);
    //   }

    //   // Update the state
    //   setContainers(updatedContainerArray);
    //   console.log(updatedContainerArray)
    // }

    const updatedData = containers.map(obj => ({
      ...obj,
      items: obj.items.filter(item => item.id !== id)
    })).filter(obj => obj.items.length > 0); // Filter out objects with non-empty items arrays

    setContainers(updatedData);

    if (currentElement?.id === id) {
      const fallback = updatedData[0]?.items?.[0]
      setCurrentElement(fallback ? { ...fallback } : {})
    }
  }

  const handelImageUpload = (e, id) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setCurrentElement({ ...currentElement, image: reader.result })
      containers.forEach(container => {
        container.items.forEach(item => {
          if (item.id === id) {
            item.image = reader.result
          }
        });
      });
      setContainers(containers);
    };
    reader.readAsDataURL(file);
  }

  const changeImageWidth = (e, id) => {
    setCurrentElement({ ...currentElement, width: (e.target.value === "" || e.target.value === "Na") ? "" : parseInt(e.target.value) })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          item.width = (e.target.value === "" || e.target.value === "Na") ? "" : parseInt(e.target.value)
        }
      });
    });
    setContainers(containers);
  }

  const changeImageHeight = (e, id) => {
    setCurrentElement({ ...currentElement, height: (e.target.value === "" || e.target.value === "Na") ? "" : parseInt(e.target.value) })
    containers.forEach(container => {
      container.items.forEach((item) => {
        if (item.id === id) {
          item.height = (e.target.value === "" || e.target.value === "Na") ? "" : parseInt(e.target.value)
        }
      });
    });
    setContainers(containers);
  }

  const handleFormData = (key, value) => {
    let newFormData = formData
    newFormData[key] = value
    setFormData({ ...newFormData })
  }

  const dragOverHandler = (e, id) => {
    e.preventDefault();
    setContainerId(id)
    const { clientX, clientY } = e;
    const containerRect = e.currentTarget.getBoundingClientRect();
    const offsetX = clientX - containerRect.left;
    const offsetY = clientY - containerRect.top;

    if (offsetY < containerRect.height / 4) {
      setPosition("above")
    } else if (offsetY > (containerRect.height / 4) * 3) {
      setPosition("below")
    } else if (offsetX < containerRect.width / 2) {
      setPosition("left")
    } else {
      setPosition("right")
    }
  };

  const isActive = canDrop && isOver;
  let backgroundColor = '#ffffff';
  if (isActive) {
    backgroundColor = '#d9edf7';
  } else if (canDrop) {
    backgroundColor = '#fcf8e3';
  }


  const autoPopulatedFieldsCheck = (value) => {
    if (autoPopulatedFields.map(field => field.toLowerCase()).includes(value.toLowerCase())) {
      setAutoPopulatedFieldsSuccess(true)
      setOutlineVisible(true)
    } else {
      setAutoPopulatedFieldsSuccess(false)
      setNameError(null)
    }
  }

  return (
    <>
      <div style={{ width: `${props.name === "panels" ? "210mm" : "70%"}` }}>
        {props.name === "panels" && <>
          <h5>Create a Panel</h5>
          <div style={{ height: "10%" }} className='d-flex gap-3 justify-content-start align-items-center'>
            <div className='d-flex align-items-center text-nowrap gap-2'>
              <label className=''>Panel Name <span className='text-danger'>*</span> </label>
              <div>
                <input type='text' className='form-control' placeholder='Enter panel name' value={panelName} onChange={(e) => {
                  setPanelName(e.target.value)
                  if (panelsList.some(panel => panel.panel_name === e.target.value)) {
                    setNameError('Panel name already exists')
                  } else {
                    setNameError(null)
                    setPanelName(e.target.value);
                  }
                }} />
                <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>

              </div>
            </div>
            <div className='d-flex align-items-center text-nowrap gap-2 w-100'>
              <label className=''>Description <span className='text-danger'>*</span> </label><input type='text' className='form-control' placeholder='Enter description' value={description} onChange={(e) => setDescription(e.target.value)} />
            </div>
          </div>
        </>}
        {props.name === "templates" && <>
          <h5>Create a Template</h5>
          <div style={{ marginBottom:"5px" }} className='d-flex gap-3 justify-content-start align-items-end flex-wrap'>
            <div className='d-flex flex-column align-items-start text-nowrap' style={{ flex: '1 1 0', minWidth: '160px' }}>
              <label className=''>Template Name <span className='text-danger'>*</span></label>
              <input type='text' className='form-control' placeholder='Enter Template Name' value={templateName} onChange={(e) => {
                setTemplateName(e.target.value)
                if (templatesList.some(template => template.template_name === e.target.value)) {
                  setNameError('Template name already exists')
                } else {
                  setNameError(null)
                  setTemplateName(e.target.value);
                }
              }} />
              <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>
            </div>
            <div className='d-flex flex-column align-items-start text-nowrap' style={{ flex: '2 1 0', minWidth: '200px' }}>
              <label className=''>Description <span className='text-danger'>*</span></label>
              <input type='text' className='form-control' placeholder='Enter description' value={description} onChange={(e) => setDescription(e.target.value)} />
            </div>
            <div className='d-flex flex-column align-items-start text-nowrap' style={{ flex: '0 0 auto' }}>
              <label className=''>Orientation</label>
              <OrientationToggle value={formOrientation} onChange={setFormOrientation} />
            </div>
          </div>
        </>}
        {props.name === "templateClone" && <>
          <h5>Create a Template Clone</h5>
          <div style={{ marginBottom:"5px" }} className='d-flex gap-3 justify-content-start align-items-end flex-wrap'>
            <div className='d-flex flex-column align-items-start text-nowrap' style={{ flex: '1 1 0', minWidth: '160px' }}>
              <label className=''>Template Name <span className='text-danger'>*</span></label>
              <input type='text' className='form-control' placeholder='Enter Template Name' value={templateName} onChange={(e) => {
                setTemplateName(e.target.value)
                if (templatesList.some(template => template.template_name === e.target.value)) {
                  setNameError('Template name already exists')
                } else {
                  setNameError(null)
                  setTemplateName(e.target.value);
                }
              }} />
              <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>
            </div>
            <div className='d-flex flex-column align-items-start text-nowrap' style={{ flex: '2 1 0', minWidth: '200px' }}>
              <label className=''>Description <span className='text-danger'>*</span></label>
              <input type='text' className='form-control' placeholder='Enter description' value={description} onChange={(e) => setDescription(e.target.value)} />
            </div>
            <div className='d-flex flex-column align-items-start text-nowrap' style={{ flex: '0 0 auto' }}>
              <label className=''>Orientation</label>
              <OrientationToggle value={formOrientation} onChange={setFormOrientation} />
            </div>
          </div>
        </>}
        {props.name === "forms" && <>
          <h5>Create a form</h5>
          <div style={{ marginBottom:"5px" }} className='d-flex gap-3 justify-content-start align-items-end flex-wrap'>
            <div className='d-flex flex-column align-items-start text-nowrap'>
              <label className=''>Form Name <span className='text-danger'>*</span></label>
              <div>
                <input type='text' className='form-control' placeholder='Enter Form Name' value={formName} onChange={(e) => {
                  setFormName(e.target.value)
                  if (formsList.some(form => form?.form_name?.toLowerCase() === e.target.value.trim().toLowerCase())) {
                    setNameError('Form name already exists')
                  } else {
                    setNameError(null)
                    setFormName(e.target.value);
                  }
                }} />
                <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>
              </div>
            </div>
            <div className='d-flex flex-column align-items-start text-nowrap'>
              <label className=''>Form Type <span className='text-danger'>*</span></label>
              <select className='form-select' value={formType} onChange={(e) => setFormType(e.target.value)}>
                <option value="" hidden>Select Form Type</option>
                <option value="sop">SOP</option>
                <option value="checklist">Checklist</option>
              </select>
            </div>
            <div className='d-flex flex-column align-items-start text-nowrap'>
              <label className=''>Description <span className='text-danger'>*</span></label><input type='text' className='form-control' placeholder='Enter description' value={description} onChange={(e) => setDescription(e.target.value)} />
            </div>
            <div className='d-flex flex-column align-items-start text-nowrap'>
              <label className=''>Orientation</label>
              <OrientationToggle value={formOrientation} onChange={setFormOrientation} />
            </div>
          </div>
        </>}
        {(props.name === "templates" || props.name === "panels" || props.name === "templateClone" || props.name === "forms") ? null : <div className='d-flex gap-2'><h5>Create a Field</h5>
          <div style={{ position: "relative" }}>
            <IoInformationCircleSharp fontSize={20} color="gray"
              onClick={() => {
                setShowFieldInfo(!showFieldInfo)
              }
              }
            />
            {!showFieldInfo && <div className='d-flex flex-column gap-2' style={{ position: "absolute", top: "30px", left: "0", width: "400px", backgroundColor: "white", padding: "10px", border: "1px solid gray", borderRadius: "5px", zIndex: "100" }}>
              <h6>Field Names</h6>
              {autoPopulatedFields.map((field, index) => {
                return <span key={index}>{index + 1}. {field}</span>
              }
              )}
              <div style={{ fontSize: "10px" }}><b>Note:-</b> Create the fields with above names to auto populate its value while filling the form</div>
            </div>}
          </div>
        </div>}
        <div className='form_preview' style={{ zIndex: 1, height: `${(props.name === "panels" || props.name === "templates" || props.name === "templateClone" || props.name === "forms") ? "75%" : "85%"}`, overflow: "auto" }} onClick={() => setShowFieldInfo(false)}>
          <div ref={drop} style={{ paddingBottom: "20px", paddingRight: "20px", width: "100%", maxWidth: (props.name === "templates" || props.name === "templateClone" || props.name === "forms") ? canvasMaxWidth : undefined, margin: (props.name === "templates" || props.name === "templateClone" || props.name === "forms") ? "0 auto" : undefined, border: (props.name === "templates" || props.name === "templateClone" || props.name === "forms") ? "1px dashed #ccc" : undefined, boxSizing: "border-box" }} className='d-flex flex-column'>
            {containers.length > 0 ? containers.map((container, index) => {
              return <div style={{ backgroundColor: container.id === containerId ? backgroundColor : "white" }} key={index} id={container.id + " " + index} onDragOver={(e) => dragOverHandler(e, container.id)} onDragOverCapture={(e) => dragOverHandler(e, container.id)} className='d-flex flex-nowrap align-items-center gap-2 flex-start container'>
                {((container.id === containerId) && (position.length > 0)) && <span>{position}</span>}
                {container.items.length > 0 && container.items.map((item, i) => {
                  return <Element key={i} content={item?.content === "" && container?.items[0]?.content}
                    preview={(props.name === "templates" || props.name === "forms") ? true : false}
                    delete={props.name === "templateClone" || props.name === "templates" || props.name === "panels" ? true : false}
                    object={item} activeId={currentElement?.id}
                    handleColumnNameChange={handleColumnNameChange}
                    handleDeleteElement={handleDeleteElement}
                    containerId={(containerId === container?.id) && containerId}
                    handleTabelData={handleTabelData}
                    handleChangeCellType={handleChangeCellType}
                    handleChangeCellOptions={handleChangeCellOptions}
                    handleChangeColumnName={handleChangeColumnName}
                    handleChangeColumnType={handleChangeColumnType}
                    handleChangeColumnOptions={handleChangeColumnOptions}
                    handleChangeColumnAlign={changeTableData}
                    handleChangeColumnHeaderAlign={handleChangeColumnHeaderAlign}
                    onUndoTable={() => handleUndoTable(item.id)}
                    onResetMerges={() => handleResetTableMerges(item.id)}
                    canUndoTable={!!(tableHistory[item.id] && tableHistory[item.id].length > 0)}
                    handleDeleteItem={handleDeleteItem}
                    onElementClick={["panels", "templates", "templateClone", "forms"].includes(props.name) ? (element) => setCurrentElement(element) : null} />
                })}
              </div>
            }) : <div style={{ minHeight: "100px", backgroundColor }}>Drag and drop elements here from left side</div>}
          </div>
        </div>
        <div className='d-flex justify-content-end align-items-center' style={{ height: "10%" }}>
          <button className='btn btn-primary secondary-button mx-3' onClick={() => {
            switch (props.name) {
              case "forms":
                navigate('/formbuilder', { state: { name: "Forms" } })
                break;
              case "templates":
                navigate('/formbuilder', { state: { name: "Templates" } })
                break;
              case "templateClone":
                navigate('/formbuilder', { state: { name: "Templates" } })
                break;
              case "panels":
                navigate('/formbuilder', { state: { name: "Panels" } })
                break;
              case "fields":
                navigate('/formbuilder', { state: { name: "Fields" } })
                break;
              default:
                break;
            }
          }}>Back</button>
          <button className='btn btn-primary primary-button' disabled={props?.name === "fields" ? containers?.length === 0 || nameError : props?.name === "panels" ? panelName?.length === 0 || description?.length === 0 || containers?.length === 0 || nameError : (props?.name === "templates" || props.name === "templateClone") ? description?.length === 0 || containers?.length === 0 || templateName?.length === 0 || nameError : props?.name === "forms" && formName?.trim()?.length === 0 || description?.trim()?.length === 0 || containers?.length === 0 || formType?.length === 0 || nameError} onClick={() => handleSave()}>Save</button>
        </div>
      </div>
      {/* {props.name === "forms" && <div>
        {
          formData && <pre>{JSON.stringify(formData, null, 2)}</pre>
        }
        </div>} */}
      {(props.name === "fields" || props.name === "templateClone" || (props.name === "panels" && containers.some(container => container.items.find(item => item.type === 'table')))) && <div className='element-settings'>
        <h5>Element properties</h5>
        {currentElement?.type === "input" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <div style={{ width: "60%", position: "relative" }}>
                <input type='text' value={currentElement.content}
                  className={`${outlineVisible ? 'outline-highlight' : ''} form-control`}
                  onChange={(e) => {
                    changeInputContent(e, currentElement.id)
                    if (props.name !== "templateClone") {
                      if (fieldsList?.some(field => field?.field_name?.toLowerCase() === e.target.value.toLowerCase())) {
                        setNameError('Field name already exists');
                      } else {
                        autoPopulatedFieldsCheck(e.target.value)
                      }
                    }
                  }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
                {props.name !== "templateClone" && autoPopulatedFieldsSuccess && <SuccessElement />}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
            {props.name !== "templateClone" && autoPopulatedFieldsSuccess && (
              <span style={{ color: "green", fontSize: "10px", fontWeight: "600" }}>Field value is auto populated for the above field name while filling the form</span>
            )}
          </FieldSection>
        </div>}
        {currentElement?.type === "inputWithLabel" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <input type='text' value={currentElement.content} className='form-control' style={{ width: "60%" }} onChange={(e) => changeInputContent(e, currentElement.id)} />
            </div>
            <div className='d-flex flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>
          </FieldSection>
          <FieldSection title="Display">
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Width</label>
              <input type='text' value={currentElement.width} className='form-control' style={{ width: "60%" }} onChange={(e) => changeParaWidth(e, currentElement.id)} />
            </div>
          </FieldSection>
        </div>}
        {currentElement?.type === "paragraph" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex flex-column gap-2 align-items-start justify-content-between'>
              <label>Label</label>
              <textarea value={currentElement.content} className='form-control' onChange={(e) => {
                changeTextContent(e, currentElement.id)
                if (props.name !== "templateClone") {
                  if (fieldsList?.some(field => field?.field_name?.toLowerCase() === e.target.value.toLowerCase())) {
                    setNameError('Field name already exists');
                  } else {
                    autoPopulatedFieldsCheck(e.target.value)
                  }
                }
              }} />
              {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
            </div>
            {props.name !== "templateClone" && <div className='d-flex flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
            {props.name !== "templateClone" && autoPopulatedFieldsSuccess && (
              <span style={{ color: "green", fontSize: "10px", fontWeight: "600" }}>Field value is auto populated for the above field name while filling the form</span>
            )}
          </FieldSection>
          <FieldSection title="Display">
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Width</label>
              <input type='text' value={currentElement.width} className='form-control' style={{ width: "60%" }} onChange={(e) => changeParaWidth(e, currentElement.id)} />
            </div>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Text Alignment</label>
              <select value={currentElement.textAlignment || "start"} className='form-select' style={{ width: "60%" }} onChange={(e) => changeTextAlignment(e, currentElement.id)}>
                <option value="start">Start</option>
                <option value="center">Center</option>
                <option value="end">End</option>
              </select>
            </div>
          </FieldSection>
        </div>}
        {currentElement?.type === "checkbox" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <div>
                <input type='text' value={currentElement.content} className='form-control' style={{ textOverflow: "ellipsis" }} onChange={(e) => {
                  changeCheckboxContent(e, currentElement.id)
                  if (props.name !== "templateClone") {
                    if (fieldsList?.some(field => field?.field_name?.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      setNameError(null);
                    }
                  }
                }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
          </FieldSection>
        </div>}
        {currentElement?.type === "textarea" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <div style={{ textOverflow: "ellipsis" }}>
                <input type='text' value={currentElement.content} className='form-control' onChange={(e) => {
                  changeTextareaLabel(e, currentElement.id)
                  if (props.name !== "templateClone") {
                    if (fieldsList?.some(field => field?.field_name?.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      setNameError(null);
                    }
                  }
                }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
          </FieldSection>
        </div>}
        {currentElement?.type === "table" && <div className='d-flex flex-column gap-3 align-items-center'>
          <div className='d-flex gap-4 align-items-center justify-content-between'>
            <label>Table Name</label>
            <input type='text' value={currentElement.content} className='form-control' onChange={(e) => handleRadioLabel(e, currentElement.id)} style={{ textOverflow: "ellipsis", width: "60%" }} />
          </div>
          <TableSidePanelSections
            currentElement={currentElement}
            setCurrentElement={setCurrentElement}
            containers={containers}
            setContainers={setContainers}
            tableHistory={tableHistory}
            handleChangeHeaderAlign={handleChangeHeaderAlign}
            handleDecreaseRows={handleDecreaseRows}
            handleIncreaseRows={handleIncreaseRows}
            handleDecreaseColumns={handleDecreaseColumns}
            handleIncreaseColumns={handleIncreaseColumns}
            handleUndoTable={handleUndoTable}
            handleResetTableMerges={handleResetTableMerges}
            handleChangeColumnName={handleChangeColumnName}
            handleChangeColumnType={handleChangeColumnType}
            handleChangeColumnOptions={handleChangeColumnOptions}
            changeTableData={changeTableData}
            handleChangeColumnHeaderAlign={handleChangeColumnHeaderAlign}
          />
        </div>}
        {currentElement?.type === "radio" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <div style={{ textOverflow: "ellipsis", width: "60%" }}>
                <input type='text' value={currentElement.content} className='form-control' onChange={(e) => {
                  handleRadioLabel(e, currentElement.id)
                  if (props.name !== "templateClone") {
                    if (fieldsList?.some(field => field.field_name.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      setNameError(null);
                    }
                  }
                }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex w-100 flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
          </FieldSection>
          <FieldSection title="Options" badge={`(${currentElement.options.length})`} defaultOpen>
            {currentElement.options.map((option, index) => (
              <div key={index} className='d-flex align-items-center gap-3'>
                {index + 1}. <input className='form-control' onChange={(e) => handleEditRadioOption(e, currentElement.id, index)} value={option.label} /> <RxCross1 title='delete' onClick={() => (handleDeleteRadioOption(currentElement.id, index))} />
              </div>
            ))}
            <button className='btn btn-light w-100' style={{ border: "1px solid lightgray" }} onClick={() => handleAddNewOption(currentElement.id)}>+ Add option</button>
          </FieldSection>
        </div>}
        {currentElement?.type === "text" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Content</label>
              <div style={{ textOverflow: "ellipsis", width: "60%" }}>
                <input type='text' value={currentElement.content} className='form-control' onChange={(e) => {
                  changeTextContent(e, currentElement.id)
                  if (props.name !== "templateClone") {
                    if (fieldsList?.some(field => field.field_name.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      autoPopulatedFieldsCheck(e.target.value)
                    }
                  }
                }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
            {props.name !== "templateClone" && autoPopulatedFieldsSuccess && (
              <span style={{ color: "green", fontSize: "10px", fontWeight: "600" }}>Field value is auto populated for the above field name while filling the form</span>
            )}
          </FieldSection>
          <FieldSection title="Display">
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Size</label>
              <select value={currentElement.size} className='form-select' style={{ width: "60%" }} onChange={(e) => changeTextSize(e, currentElement.id)}>
                <option value="h1">Largest</option>
                <option value="h2">Larger</option>
                <option value="h3">Large</option>
                <option value="h4">Medium</option>
                <option value="h5">Smaller</option>
                <option value="h6">Smallest</option>
              </select>
            </div>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Text Alignment</label>
              <select value={currentElement.textAlignment || "start"} className='form-select' style={{ width: "60%" }} onChange={(e) => changeTextAlignment(e, currentElement.id)}>
                <option value="start">Start</option>
                <option value="center">Center</option>
                <option value="end">End</option>
              </select>
            </div>
          </FieldSection>
        </div>}
        {currentElement?.type === "toggle" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <div style={{ textOverflow: "ellipsis", width: "60%" }}>
                <input type='text' value={currentElement.content} className='form-control' onChange={(e) => {
                  changeToggleContent(e, currentElement.id)
                  if (props.name !== "templateClone") {
                    if (fieldsList?.some(field => field.field_name.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      setNameError(null);
                    }
                  }
                }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex w-100 flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
          </FieldSection>
        </div>}
        {currentElement?.type === "date" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <div style={{ textOverflow: "ellipsis", width: "60%", position: "relative" }}>
                <input type='text' value={currentElement.content} className='form-control' onChange={(e) => {
                  changeToggleContent(e, currentElement.id)
                  if (props.name !== "templateClone") {
                    if (fieldsList?.some(field => field.field_name.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      autoPopulatedFieldsCheck(e.target.value)
                    }
                  }
                }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
                {props.name !== "templateClone" && autoPopulatedFieldsSuccess && <SuccessElement />}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex w-100 flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
            {props.name !== "templateClone" && autoPopulatedFieldsSuccess && (
              <span style={{ color: "green", fontSize: "10px", fontWeight: "600" }}>Field value is auto populated for the above field name while filling the form</span>
            )}
          </FieldSection>
        </div>}
        {currentElement?.type === "toggleInput" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <input type='text' value={currentElement.content} className='form-control' style={{ textOverflow: "ellipsis", width: "60%" }} onChange={(e) => changeToggleContent(e, currentElement.id)} />
            </div>
            {props.name !== "templateClone" && <div className='d-flex w-100 flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
          </FieldSection>
        </div>}
        {currentElement?.type === "dropdown" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Label</label>
              <div style={{ textOverflow: "ellipsis", width: "60%", position: "relative" }}>
                <input type='text' value={currentElement.content} className='form-control' onChange={(e) => {
                  handleRadioLabel(e, currentElement.id)
                  if (props.name !== "templateClone") {
                    if (fieldsList?.some(field => field.field_name.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      autoPopulatedFieldsCheck(e.target.value)
                    }
                  }
                }} />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
                {props.name !== "templateClone" && autoPopulatedFieldsSuccess && <SuccessElement />}
              </div>
            </div>
            {props.name !== "templateClone" && <div className='d-flex w-100 flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
            {props.name !== "templateClone" && autoPopulatedFieldsSuccess && (
              <span style={{ color: "green", fontSize: "10px", fontWeight: "600" }}>Field value is auto populated for the above field name while filling the form</span>
            )}
          </FieldSection>
          <FieldSection title="Options" badge={`(${currentElement.options.length})`} defaultOpen>
            {currentElement.options.map((option, index) => (
              <div key={index} className='d-flex align-items-center gap-3'>
                {index + 1}. <input className='form-control' onChange={(e) => handleEditdropdownOption(e, currentElement.id, index)} value={option} /> <RxCross1 title='delete' onClick={() => (handleDeleteDropdownOption(currentElement.id, index))} />
              </div>
            ))}
            <button className='btn btn-light w-100' style={{ border: "1px solid lightgray" }} onClick={() => handleAddNewDropdownOption(currentElement.id)}>+ Add option</button>
          </FieldSection>
        </div>}
        {currentElement?.type === "image" && <div className='d-flex flex-column'>
          <FieldSection title="Basics" defaultOpen>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Image Name</label>
              <div style={{ textOverflow: "ellipsis", width: "60%", position: "relative" }}>
                <input type='text' value={currentElement.content} className='form-control' onChange={
                  (e) => {
                    handleRadioLabel(e, currentElement.id)
                    if (props.name !== "templateClone" && fieldsList?.some(field => field.field_name.toLowerCase() === e.target.value.toLowerCase())) {
                      setNameError('Field name already exists');
                    } else {
                      setNameError(null);
                    }
                  }
                } />
                {props.name !== "templateClone" && <span style={{ color: "red", fontSize: "10px" }}>{nameError}</span>}
              </div>
            </div>
            <div className='d-flex w-100 flex-column gap-2 align-items-start justify-content-between'>
              <label>Select Image</label>
              <input type="file" accept='image/*' onChange={(e) => handelImageUpload(e, currentElement.id)} />
            </div>
            {props.name !== "templateClone" && <div className='d-flex w-100 flex-column gap-2 align-items-start justify-content-between'>
              <label>Description</label>
              <textarea className='form-control' onChange={(e) => setDescription(e.target.value)} />
            </div>}
          </FieldSection>
          <FieldSection title="Display">
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Width</label>
              <input type='number' value={currentElement.width} className='form-control' style={{ width: "60%" }} onChange={(e) => changeImageWidth(e, currentElement.id)} />
            </div>
            <div className='d-flex gap-4 align-items-center justify-content-between'>
              <label>Height</label>
              <input type='number' value={currentElement.height} className='form-control' style={{ width: "60%" }} onChange={(e) => changeImageHeight(e, currentElement.id)} />
            </div>
          </FieldSection>
        </div>
        }
      </div>}
      {creationError && <AlertPopUp
        alertShow={creationError}
        alertType="error"
        alertMsg="Error"
        alertValue={creationError}
        alertButtons={[{
          name: "Back", action: () => {
            dispatch({
              type: CREATION_ERROR,
              variant: "secondary",
              payload: null
            })
          }
        },
        {
          name: "Retry", action: () => {
            handleSave()
            dispatch({
              type: CREATION_ERROR,
              payload: null
            })
          }
        }
        ]}
      />}

    </>
  );
};

export default FormCanvas;


const SuccessElement = () => {
  return <div className='d-flex justify-content-center align-items-center' style={{ backgroundColor: "green", position: "absolute", right: "7px", top: "7px", color: "white", border: "2px solid green", borderRadius: "50%", padding: "1px", width: "20px", height: "20px" }}>
    <TiTick />
  </div>
}

const FieldSection = ({ title, badge, defaultOpen = false, children }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  return (
    <div style={{ border: '1px solid #e0e0e0', borderRadius: '4px', marginBottom: '6px', background: 'white' }}>
      <button
        type='button'
        onClick={() => setIsOpen(o => !o)}
        style={{
          width: '100%',
          background: isOpen ? '#f3f3f3' : 'white',
          border: 'none',
          padding: '8px 10px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          color: '#333',
        }}
      >
        <span>{title}{badge != null && <span style={{ marginLeft: '8px', fontSize: '10px', color: '#666', fontWeight: 400 }}>{badge}</span>}</span>
        <span style={{ fontSize: '10px', color: '#666' }}>{isOpen ? '▾' : '▸'}</span>
      </button>
      {isOpen && (
        <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {children}
        </div>
      )}
    </div>
  )
}

const TableSidePanelSections = ({
  currentElement,
  setCurrentElement,
  containers,
  setContainers,
  tableHistory,
  handleChangeHeaderAlign,
  handleDecreaseRows,
  handleIncreaseRows,
  handleDecreaseColumns,
  handleIncreaseColumns,
  handleUndoTable,
  handleResetTableMerges,
  handleChangeColumnName,
  handleChangeColumnType,
  handleChangeColumnOptions,
  changeTableData,
  handleChangeColumnHeaderAlign,
}) => {
  const hasDropdown = (currentElement.columnsType || []).some((t) => t === 'dropdown')

  return (
    <div style={{ width: '100%', marginTop: '6px' }}>
      <FieldSection title='Basics' defaultOpen>
        <div className='d-flex align-items-center justify-content-between'>
          <label style={{ fontSize: '12px' }}>Show Header</label>
          <input
            type='checkbox'
            checked={currentElement.showHeader}
            onChange={(e) => {
              setCurrentElement({ ...currentElement, showHeader: e.target.checked });
              containers.forEach((container) => {
                container.items.forEach((item) => {
                  if (item.id === currentElement.id) {
                    item.showHeader = e.target.checked;
                  }
                });
              });
              setContainers(containers);
            }}
          />
        </div>
        {currentElement.showHeader && (
          <div style={{ fontSize: '11px', color: '#666' }}>
            Header alignment is now per column. Right-click a header in the table, or use the alignment dropdown under each column below.
          </div>
        )}
        <div className='d-flex align-items-center justify-content-between'>
          <label style={{ fontSize: '12px' }}>Rows</label>
          <div className='d-flex gap-1 align-items-center'>
            <button className='btn btn-light btn-sm' onClick={() => handleDecreaseRows(currentElement.id)}>-</button>
            <span style={{ minWidth: '24px', textAlign: 'center' }}>{currentElement.rows}</span>
            <button className='btn btn-light btn-sm' onClick={() => handleIncreaseRows(currentElement.id)}>+</button>
          </div>
        </div>
        <div className='d-flex align-items-center justify-content-between'>
          <label style={{ fontSize: '12px' }}>Columns</label>
          <div className='d-flex gap-1 align-items-center'>
            <button className='btn btn-light btn-sm' onClick={() => handleDecreaseColumns(currentElement.id)}>-</button>
            <span style={{ minWidth: '24px', textAlign: 'center' }}>{currentElement.columns}</span>
            <button className='btn btn-light btn-sm' onClick={() => handleIncreaseColumns(currentElement.id)}>+</button>
          </div>
        </div>
      </FieldSection>

      <FieldSection title='Columns' badge={`(${currentElement.columnNames.length})`} defaultOpen>
        <div style={{ fontSize: '11px', color: '#666' }}>Tip: right-click a header in the table for the same controls.</div>
        {currentElement.columnNames.map((columnName, index) => (
          <div key={index} style={{ border: '1px solid #eee', borderRadius: '4px', padding: '8px' }}>
            <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>Column {index + 1}</div>
            <input
              className='form-control form-control-sm mb-2'
              value={columnName}
              placeholder='Column name'
              onChange={(e) => handleChangeColumnName(e, index, currentElement.id)}
            />
            <div className='d-flex gap-2 mb-2'>
              <select
                className='form-control form-control-sm'
                style={{ flex: 1 }}
                value={currentElement.columnsType?.[index] || 'text'}
                onChange={(e) => handleChangeColumnType(e, currentElement.id, index)}
              >
                <option value='text'>text</option>
                <option value='toggle'>toggle</option>
                <option value='input'>input</option>
                <option value='image'>image</option>
                <option value='dropdown'>dropdown</option>
                <option value='date'>date</option>
              </select>
            </div>
            <div className='d-flex gap-2'>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '10px', color: '#666', marginBottom: '2px' }}>Header align</div>
                <select
                  className='form-control form-control-sm'
                  value={currentElement.columnsHeaderAlign?.[index] || currentElement.headerAlign || 'start'}
                  onChange={(e) => handleChangeColumnHeaderAlign && handleChangeColumnHeaderAlign(e, currentElement.id, index)}
                >
                  <option value='start'>start</option>
                  <option value='center'>center</option>
                  <option value='end'>end</option>
                </select>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '10px', color: '#666', marginBottom: '2px' }}>Cell align</div>
                <select
                  className='form-control form-control-sm'
                  value={currentElement.tableData?.[0]?.[index]?.textAlign || 'start'}
                  onChange={(e) => changeTableData(e, currentElement.id, index)}
                >
                  <option value='start'>start</option>
                  <option value='center'>center</option>
                  <option value='end'>end</option>
                </select>
              </div>
            </div>
          </div>
        ))}
      </FieldSection>

      {hasDropdown && (
        <FieldSection title='Per-column dropdown options'>
          {currentElement.columnNames.map((columnName, index) => (
            currentElement.columnsType?.[index] === 'dropdown' ? (
              <div key={index}>
                <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>{columnName}</div>
                <input
                  className='form-control form-control-sm'
                  placeholder='e.g. Yes, No, Maybe'
                  value={currentElement.columnsOptions && currentElement.columnsOptions[index] ? currentElement.columnsOptions[index] : ''}
                  onChange={(e) => handleChangeColumnOptions(e, currentElement.id, index)}
                />
              </div>
            ) : null
          ))}
        </FieldSection>
      )}
    </div>
  )
}

const OrientationToggle = ({ value, onChange }) => {
  const baseBtn = { display: "flex", alignItems: "center", gap: "4px", padding: "4px 10px", fontSize: "12px", border: "1px solid #ccc", background: "white", color: "#333", cursor: "pointer" }
  const activeBtn = { background: "#525252", color: "white", borderColor: "#525252" }
  return (
    <div role="radiogroup" aria-label="Form orientation" style={{ display: "inline-flex", borderRadius: "4px", overflow: "hidden" }}>
      <button type="button" role="radio" aria-checked={value === "portrait"} onClick={() => onChange("portrait")} style={{ ...baseBtn, borderTopLeftRadius: "4px", borderBottomLeftRadius: "4px", borderRight: "none", ...(value === "portrait" ? activeBtn : {}) }}>
        <MdCropPortrait size={14} /> Portrait
      </button>
      <button type="button" role="radio" aria-checked={value === "landscape"} onClick={() => onChange("landscape")} style={{ ...baseBtn, borderTopRightRadius: "4px", borderBottomRightRadius: "4px", ...(value === "landscape" ? activeBtn : {}) }}>
        <MdCropLandscape size={14} /> Landscape
      </button>
    </div>
  )
}